import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
  Center,
} from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <Box minH="100vh" bg="gray.50" py={8}>
      <Container maxW="container.md">
        <Center h="60vh">
          <Box
            bg="white"
            borderRadius="lg"
            borderWidth="1px"
            p={12}
            shadow="lg"
            textAlign="center"
          >
            <VStack spacing={6}>
              <CheckCircleIcon boxSize={16} color="green.500" />
              <Heading size="xl" color="black">
                Evaluation Completed
              </Heading>
              <Text fontSize="md" color="gray.600" maxW="md">
                Thank you for completing the evaluation. Your responses have been submitted successfully.
              </Text>
              <Button
                bg="rgb(37, 87, 167)"
                color="white"
                _hover={{ bg: "rgb(27, 67, 137)" }}
                _active={{ bg: "rgb(17, 47, 107)" }}
                size="lg"
                onClick={() => navigate('/')}
                mt={4}
              >
                Return Home
              </Button>
            </VStack>
          </Box>
        </Center>
      </Container>
    </Box>
  );
};

export default SuccessPage; 